import { ReaderApiClient } from '../reader-api-client';
import { RemoveRequest } from '../../requests/remove-request';
import { Observable } from 'rxjs';
import { ServiceResponse } from '../../responses/service-response';
import { CrudHttpCommunication } from './crud-http-communication';
import { StoreRequest } from '../../requests/store-request';
import { CreateResponse } from '../../responses/create-response';
import { StoreResponse } from '../../responses/store-response';
import { HttpHeaders } from '@angular/common/http';
import { PinIdentityToDashboardDto } from '../../requests/pin-identity-to-dashboard.dto';
import { GenericServiceRequest } from '../../requests/generic-service-request';
import { Injectable } from '@angular/core';
import { CacheOptionsInterface, CrudApiClientInterface, IdentityInterface, ModelInterface, StoreResponseInterface } from '@nts/std/interfaces';


@Injectable()
export class CrudApiClient<TModel extends ModelInterface<TIdentity>, TIdentity extends IdentityInterface>
    extends ReaderApiClient<TModel, TIdentity>
    implements CrudApiClientInterface<TIdentity, TModel> {

    protected createCrudHttpCommunication(): CrudHttpCommunication {
        return new CrudHttpCommunication(this.agent);
    }

    create(
        responseInstance = new CreateResponse<TModel, TIdentity>(this.rootModelType),
        cacheOptions: CacheOptionsInterface = {
            bypass: false,
            expirationTime: undefined,
            force: false,
        },
        customHeaders: HttpHeaders = null
    ): Observable<CreateResponse<TModel, TIdentity>> {

        // Default for create
        cacheOptions = {
            bypass: false,                         
            expirationTime: undefined,                  
            force: false,
            enterpriseBarrier: false,
            tenantBarrier: true,
            ...cacheOptions
        };

        const communication = this.createCrudHttpCommunication();
        return communication.create<TModel, TIdentity>(
            this.rootModelType,
            responseInstance,
            cacheOptions,
            customHeaders
        );
    }

    createML(
        responseInstance = new CreateResponse<TModel, TIdentity>(this.rootModelType),
        cacheOptions: CacheOptionsInterface = {
            bypass: false,
            expirationTime: undefined,
            force: false,
        },
    ): Observable<CreateResponse<TModel, TIdentity>> {
        const communication = this.createCrudHttpCommunication();
        return communication.createML<TModel, TIdentity>(
            this.rootModelType,
            responseInstance,
            cacheOptions
        );
    }

    remove(request: RemoveRequest<TIdentity>): Observable<ServiceResponse> {
        const communication = this.createCrudHttpCommunication();
        return communication.remove<TIdentity>(request);
    }

    store(
        request: StoreRequest<TModel>,
        responseInstance = new StoreResponse<TModel, TIdentity>(this.rootModelType),
    ): Observable<StoreResponseInterface<TModel, TIdentity>> {
        const communication = this.createCrudHttpCommunication();
        return communication.store<TModel, TIdentity>(
            request, this.rootModelType, 
            responseInstance
        );
    }

    pinIdentityToDashboard(request: GenericServiceRequest<PinIdentityToDashboardDto<TIdentity>>): Observable<ServiceResponse> {
        const communication = this.createCrudHttpCommunication();
        return communication.pinIdentityToDashboard<TIdentity>(request);
    }
}
